import React from "react";
import "../styles/Bilgitoplum.css";
import { useLanguage } from "../contexts/LanguageContext";

const Bilgitoplum = () => {
  const { t } = useLanguage();
  const rows = [
    [t('bilgitoplum.sirketTuru'), "A.Ş."],
    [t('bilgitoplum.mersis'), "0458049158700001"],
    [t('bilgitoplum.ticaretSicil'), "776303"],
    [t('bilgitoplum.ticaretUnvani'), "HAS GÜMÜŞ DEĞERLİ MADENLER DIŞ TİC. VE SAN. A.Ş"],
    [t('bilgitoplum.adres'), "BEYAZIT MAH./ŞENT ÇARŞIKAPI NUR-U OSMANİYE CAD. NO:43 İÇ KAPI NO:1 FATİH/İSTANBUL"],
    "HEADER",
    [t('bilgitoplum.telefon'), "0212 514 88 53 – 0212 514 88 56"],
    [t('bilgitoplum.fax'), "0212 511 88 57"],
    [t('bilgitoplum.eposta'), "info@hasgumus.com"],
    [t('bilgitoplum.taahhutEdilenSermaye'), "300.000.000,00 TL"],
    [t('bilgitoplum.odenenSermaye'), "300.000.000,00 TL"],
    [t('bilgitoplum.sirketTarih'), "14.05.2013"],
    [t('bilgitoplum.kurulduguUlke'), "TÜRKİYE"],
    [t('bilgitoplum.vergiDairesi'), "Hocapaşa"],
    [t('bilgitoplum.vergiNumarasi'), "4580491587"],
    [t('bilgitoplum.sektor'), "KIYMETLİ MADEN ALIM SATIMI"],
    [t('bilgitoplum.yonetimKuruluBaskani'), "Özcan Türkmen"],
    [t('bilgitoplum.yonetimKuruluBaskanYardimcisi'), "Metin Sipahioglu"],
    [t('bilgitoplum.yonetimKuruluUyesi'), "Ercan Türkmen"],
    [t('bilgitoplum.genelMudur'), "Fahri Marabi"],
    [t('bilgitoplum.denetci'), <>Edit Bağımsız Denetim Hizmetleri A.Ş.<br/>
    Kaptanpaşa Mah. Darülaceze Cad. No:33 Bilaş İş Merkezi B Blok K:5 D:60 Şişli/İSTANBUL</>],
  ];
  let rowIndex = 0;
  return (
    <div className="bilgitoplum-container">
      <table className="bilgitoplum-table">
        <tbody>
          {rows.map((row, idx) => {
            if (row === "HEADER") {
              // Header satırı için özel class ve animasyon gecikmesi
              return (
                <tr
                  className="bilgitoplum-header-row"
                  key={"header-row"}
                  style={{ animationDelay: `${rowIndex * 0.08 + 0.1}s` }}
                >
                  <td colSpan={2}>{t('bilgitoplum.iletisimBilgileri')}</td>
                </tr>
              );
            } else {
              const delay = rowIndex * 0.08 + 0.1;
              rowIndex++;
              return (
                <tr key={idx} style={{ animationDelay: `${delay}s` }}>
                  <td>{row[0]}</td>
                  <td>{row[1]}</td>
                </tr>
              );
            }
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Bilgitoplum;
